import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import './ProcessNodes.css';

/**
 * Gate Node - For AND/OR/THRESHOLD flow control
 */
function GateNode({ data, selected }) {
  const gateType = data.gate_type || 'AND';
  const threshold = data.threshold;
  const inputCount = data.input_nodes?.length || 0;
  const outputCount = data.output_nodes?.length || 0;

  const getGateIcon = () => {
    switch (gateType) {
      case 'AND':
        return '◆';
      case 'OR':
        return '◇';
      case 'THRESHOLD':
        return '⬡';
      default:
        return '◆';
    }
  };

  const getGateColor = () => {
    switch (gateType) {
      case 'AND':
        return 'and';
      case 'OR':
        return 'or';
      case 'THRESHOLD':
        return 'threshold';
      default:
        return 'and';
    }
  };

  return (
    <div className={`process-node gate-node gate-${getGateColor()} ${selected ? 'selected' : ''}`}>
      {/* Input Handles */}
      <Handle
        type="target"
        position={Position.Left}
        className="node-handle input-handle"
      />

      {/* Node Content */}
      <div className="gate-content">
        <div className="gate-icon">{getGateIcon()}</div>
        <div className="gate-info">
          <div className="gate-type">{gateType}</div>
          {gateType === 'THRESHOLD' && threshold && (
            <div className="gate-threshold">≥{threshold}</div>
          )}
        </div>
      </div>

      <div className="gate-meta">
        <span className="meta-item" title="Inputs">
          {inputCount} in
        </span>
        <span className="meta-item" title="Outputs">
          {outputCount} out
        </span>
      </div>

      {/* Output Handle */}
      <Handle
        type="source"
        position={Position.Right}
        className="node-handle output-handle"
      />
    </div>
  );
}

export default memo(GateNode);
